(function(angular){
	'use strict';

	angular
		.module('metroMarketMapModule')
		.directive('metroMarketMap', [
			'$filter', 
			'$interpolate', 
			'$q', 
			'$timeout', 
			'$templateRequest',
			'BREAKPOINTS', 
			'ReitService',
			'STATIC_BASE_PATH', 
			marketingDiversificationMapFunction
		]);

	function marketingDiversificationMapFunction(
		$filter,
		$interpolate,
		$q,
		$timeout,
		$templateRequest,
		BREAKPOINTS,
		ReitService,
		STATIC_BASE_PATH) {
		return {
			replace: true,
			restrict: 'E',
			scope: {
				mapboxAccessToken: '@'
			},
			templateUrl: STATIC_BASE_PATH + '/static/html/shared/charts/metro-market-map/metro-market-map.html',
			link: function($scope, $attrs, $elem) {
				
				$scope.reitAssets = ReitService.reitAssetsPromise();
				$scope.offeringAssets = ReitService.offeringAssetsPromise();
				
				$q.all([$scope.reitAssets, $scope.offeringAssets]).then(function(values){
					$scope.mapIsDirty = false;
					$scope.geoJson = [];
					
					function generateReitOfferingData(){
						var realEstateAssets = [];
						var totalSizeOfAllAssets = 0;

						angular.forEach(values, function(element){
							element.assets.forEach(function(asset){
								realEstateAssets.push(asset);
							});

							totalSizeOfAllAssets += element.totalSize;
						});
						
						if (window.innerWidth >= BREAKPOINTS.MD_START){
							var featuredAssetsData = generateMapData(realEstateAssets);
							initMap(featuredAssetsData);
						}
					}
					
					function generateMapData(assets) {
						var geoJson = { 'type' : 'FeatureCollection', 'features' : [] };
		
						angular.forEach(assets, function(property) {
							
							if(typeof(property.lon) === 'number' && typeof(property.lat) === 'number') {
								var featuredAsset = {
									"type": "Feature",
									"geometry": {
										"type": "Point",
										"coordinates": [
											property.lon,
											property.lat
										]
									},
									"properties": {
										'location' : property.cityAndState,
										'imageUrl' : property.imageUrl,
										'type' : $filter('propertyType')(property.type)
									}
								};
								
								geoJson.features.push(featuredAsset);
							}
						});
						
						$scope.geoJson = geoJson;
		
						return geoJson;
					}
	
					function initMap(data) {
						mapboxgl.accessToken = $scope.mapboxAccessToken;
						
						var map = new mapboxgl.Map({
							attributionControl: false,
							center: [-98.5795, 39.8283],
							container: 'js-geographic-diversification-map',
							scrollZoom: false,
							style: 'mapbox://styles/kennyfundrise/cj1ycborj000a2sl2n6k28n4f',
							zoom: 3
						});
						
						map.on("load", function() {
						
							map.addSource("realEstateAssets", {
								type: "geojson",
								data: data,
								cluster: true,
								clusterMaxZoom: 10,
								clusterRadius: 25
							});
	
							map.addLayer({
								id: "clusters",
								type: "circle",
								source: "realEstateAssets",
								filter: ["has", "point_count"],
								paint: {
									"circle-color": "#F47735",
									"circle-radius": 12,
									"circle-stroke-color": "#F47735",
									"circle-stroke-opacity": 0.5,
									"circle-stroke-width": {
										property: "point_count",
										type: "identity"
									}
								}
							});
	
							map.addLayer({
								id: "cluster-count",
								type: "symbol",
								source: "realEstateAssets",
								filter: ["has", "point_count"],
								layout: {
									"text-field": "{point_count_abbreviated}",
									"text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
									"text-size": 12
								},
								paint: {
									"text-color": "#ffffff"
								}
							});
	
							map.addLayer({
								id: "unclustered-point",
								type: "circle",
								source: "realEstateAssets",
								filter: ["!has", "point_count"],
								paint: {
									"circle-color": "#F47735",
									"circle-radius": 6
								}
							});
							
							map.on('click', 'clusters', function(e){
								map.flyTo({
									center: [e.lngLat.lng, e.lngLat.lat],
									zoom: (map.style.z + 2)
								});
							});

							map.on('mouseenter', 'clusters', function () {
								map.getCanvas().style.cursor = 'pointer';
							});

							map.on('mouseleave', 'clusters', function () {
								map.getCanvas().style.cursor = '';
							});
							
							var templateUrl = STATIC_BASE_PATH + '/static/html/shared/charts/geographic-diversification-map/geographic-diversification-popup-no-rating.html';
							
							$templateRequest(templateUrl).then(function(html){
								var markup = html;
								
								map.on('click', 'unclustered-point', function(e) {
									var newScope = $scope.$new(true);
									
									var context = {
										imageUrl: e.features[0].properties.imageUrl,
										type: e.features[0].properties.type,
										location: e.features[0].properties.location,
										hasRating: false
									};
									
									newScope.context = context;
									var template = $interpolate(markup)(newScope);
									
									new mapboxgl.Popup({closeButton: false})
										.setLngLat(e.features[0].geometry.coordinates)
										.setHTML(template)
										.addTo(map);
								});
								
								map.on('mouseenter', 'unclustered-point', function () {
									map.getCanvas().style.cursor = 'pointer';
								});
								
								map.on('mouseleave', 'unclustered-point', function () {
									map.getCanvas().style.cursor = '';
								});
								
								map.on('moveend', function(e) {
									if(e.reset) {
										$scope.mapIsDirty = false;
									} else {
										$scope.mapIsDirty = true;
									}
									$scope.$apply();
								});
							});
							
							$timeout(function(){
								map.resize();
							});

							$scope.zoomOut = function() {
								map.zoomOut();
							};

							$scope.zoomIn = function() {
								map.zoomIn();
							};

							$scope.reset = function() {
								map.flyTo({center: [-98.5795, 39.8283], zoom: 3},{reset: true});
							};
						});
					}

					if (mapboxgl.supported()) {
						generateReitOfferingData();
					} else {
						document.getElementById('js-geographic-diversification-map').className = 'display-none';
					}
				});
			}
		};
	}
})(window.angular);